<template v-if="pageRender">
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Penjualan</h1>
            <div class="section-header-breadcumb button">
                <select class="form-control" v-model="tipePenjualan" name="tipe_penjualan" id="">
                    <option value="pemesanan">Pemesanan Penjualan</option>
                    <option value="pengiriman">Pengiriman Penjualan</option>
                    <option value="penagihan">Penagihan Penjualan</option>
                </select>
            </div>
          </div>
        <div class="section-body">
            <h2 class="section-title">Buat {{ tipePenjualan }} penjualan</h2>
            <div class="row">
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Pelanggan</h4> <span @click="showAddNewKontak()" style="color:#8B008B;cursor:pointer">+ Tambah Kontak</span>
                        </div>
                        <div class="card-body" style="min-height:350px;">
                            <div class="form-group">
                                <label>Pelanggan</label>
                                <select id="pelanggan" class="form-control select2">
                                    <option v-for="(option,index) in pelangganList" v-bind:key="option.id_kontak" :value="index" >{{ option.display_name}} </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Alamat Pelanggan</label>
                                <textarea class="form-control" v-model="alamat" @focus="auto_alamat()"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <input type="text" v-model="email" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Detail Transaksi</h4>
                        </div>
                        <div class="card-body" style="min-height:350px;">
                            <div class="form-group">
                                <label>Nomor Transaksi</label>
                                <input type="text" v-model="nomor_transaksi" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Tanggal Transaksi</label>
                                <vc-date-picker v-model="tanggal_transaksi" :input-props='{class: "form-control",placeholder: "Masukkan tanggal transaksi",}'/>
                            </div>
                            <div class="form-group">
                                <label>Tanggal Jatuh Tempo</label>
                                <vc-date-picker v-model="tanggal_tempo" :input-props='{class: "form-control",placeholder: "Masukkan tanggal jatuh tempo"}'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Tambahan</h4>
                        </div>
                        <div class="card-body" style="min-height:350px;">
                            <div class="form-group">
                                <label>Pesan</label>
                                <textarea class="form-control" v-model="pesan" ></textarea>
                            </div>
                            <div class="form-group mb-0">
                                <label>Memo</label>
                                <textarea class="form-control" v-model="memo" ></textarea>
                            </div>
                            <!-- <div class="form-group">
                                <label>Lampiran</label>
                                <input type="file" class="form-control">
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>List Produk</h4>
                            <div class="card-header-action">
                                <button @click="showModalUpload()" class="btn btn-outline-info"><i class="fa fa-upload"></i>  Import Data Produk</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table v-if="bodyRender" class="table table-striped table-md">
                                    <tr>
                                        <th>Produk</th>
                                        <th>Stok Tersedia</th>
                                        <th>Satuan</th>
                                        <th>Kuantitas</th>
                                        <th></th>
                                        <!-- <th>Harga Satuan</th>
                                        <th>Jumlah</th> -->
                                    </tr>
                                    <tr v-for="(data,index) in dataProdukList" v-bind:key="index">
                                        <td>
                                            <div class="form-group">
                                                <v-select :id="'produk_'+index" v-model="dataProdukList[index].val" :reduce="text => text.value" :options="produkList" label="text" @input="insertValue(index)"></v-select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="dataProdukList[index].qty_total" disabled>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="data.nama_satuan" disabled>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="number" :max="dataProdukList[index].qty_total" min="0" @input="countHarga(index)" v-on:keyup.enter="addItem()" class="form-control" v-model="data.qty">
                                            </div>
                                        </td>
                                        <td> <i @click="deleteDataProduk(index)" style="font-size:18px;cursor:pointer;color:red;" class="fa fa-times"></i>  </td>

                                        <!-- <td>
                                            <div class="form-group">
                                                <input type="text" @change="countHarga(index)" class="form-control" v-model="data.harga_satuan">
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" @change="countSatuan(index)" v-model="data.jumlah_harga">
                                            </div>
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td style="padding-top:5%;">
                                            <button @click="addItem()" class="btn btn-primary">+ Tambah Data</button>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <th colspan="4" style="text-align:right">Dibayar</th>
                                        <th>
                                            <div class="form-group">
                                                <input type="text" v-model="dibayar" v-imask="mask" class="form-control">
                                            </div>
                                        </th>
                                    </tr> -->
                                    <!-- <tr>
                                        <th style="text-align:right" colspan="4">Total Tagihan</th>
                                        <th>Rp. {{ currencyFormat(total_semua) }}</th>
                                    </tr> -->

                                </table>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="goBack()" class="btn btn-danger"><i class="fas fa-times"></i> Batal</button>
                    <button v-if="type == 'new'" @click="submit('normal')" class="btn btn-success">Buat Penjualan</button>
                    <button v-if="type == 'new'" @click="submit('next')" class="btn btn-primary">Buat & Baru</button>
                    <button v-if="type == 'edit'" @click="submit('edit')" class="btn btn-outline-success">Update Transaksi</button>
                </div>
            </div>
        </div>
        </section>
        <div class="modal show"  v-if="showAddKontak">
            <div class="modal-content">
                <add-kontak></add-kontak>
            </div>
        </div>
        <modal name="import-data">
            <div class="card">
                <div class="card-header">
                    <h4>Import Data Produk</h4>
                </div>
                <div class="card-body text-center">
                    <p>1. Download template dibawah lalu isi sesuai contoh data.</p>
                    <a :href="siteUrl+'Transaksi/downloadTemplateImport'" class="btn btn-outline-primary text-center"> <i class="fa fa-download"></i> Download Template</a>
                    <p>2. Upload template yang sudah diisi sesuai data.</p>
                    <vue-xlsx-table @on-select-file="handleSelectedFile"> <i class="fa fa-upload"></i> Pilih File Template</vue-xlsx-table>
                    <!-- <div class="custom-file">
                      <input type="file" class="custom-file-input" id="customFile">
                      <label class="custom-file-label" for="customFile">{{ fileLabel }}</label>
                    </div> -->
                </div>
                <div class="card-footer">

                </div>
            </div>
        </modal>
    </div>
</template>
<style>
.vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: flex;
    padding: 7px 4px 7px 4px;
    background: none;
    border: 1px solid #e4e6fc;
    border-radius: 4px;
    white-space: normal;
    min-width: 360px;
}
.vs__actions {
    padding: 0px 6px 0 3px;
}
.vs__clear {
    display:none;
}
.vs__dropdown-menu {
    background-color: white;
    border: 1px solid #aaa;
    border-radius: 4px;
    box-sizing: border-box;
    display: block;
    position: absolute;
    z-index: 3000;
    max-height: 120px !important;
}

.modal {
  padding-top: 5%; /* Location of the box */
  padding-bottom: 5%;
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 80%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s
}

.show {
    display : block !important;
}

@-webkit-keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

@keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

.xlsx-button {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    padding: .3rem .8rem;
    letter-spacing: .5px;
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

</style>

<script>
import Vue from 'vue'
import {IMaskDirective} from 'vue-imask';
import vSelect from 'vue-select'
import VCalendar from 'v-calendar';
import AddKontak from '../kontak/KontakBaruLite.vue'
import VModal from 'vue-js-modal'
import vueXlsxTable from 'vue-xlsx-table'
import housecall from 'housecall'

Vue.component('v-select', vSelect)

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'pt-PT': {
      firstDayOfWeek: 1,
      masks: {
        L: 'YYYY-MM-DD',
        input : 'YYYY-MM-DD'
      }
    }
  }
});

Vue.use(VModal)
Vue.use(vueXlsxTable, {rABS: false})

var future = new Date();
future.setDate(future.getDate() + 30);

var queue = housecall({ concurrency: 2, cooldown: 300 });

export default {
    data() {
        return {
            type : 'new',
            id_transaksi : '',
            transaksiDetail : [],
            tipePenjualan : '',
            nomor_transaksi : '',
            tanggal_transaksi : new Date(),
            tanggal_tempo : future,
            pesan : '',
            memo : '',
            lampiran : '',
            produkList : [],
            pelangganList : [],
            pelanggan: '',
            alamat : '',
            email : [],
            dataProdukList : [],
            potongan : '',
            mask: {
                mask: Number,
                thousandsSeparator: '.',
                normalizeZeros: false,
            },
            dibayar : '0',
            vcattrs: [
                {
                    key: 'today',
                    highlight: true,
                    dates: new Date(),
                },
            ],
            url : '',
            jenis_transaksi : '',
            auto : '',
            total_tagihan : 0,
            showAddKontak : false,
            fileLabel : 'Pilih File',
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
            bodyRender : true,
            pageRender : true,
        }
    },
    mounted() {
        if(this.$route.params.id_transaksi != null) {
            this.type = 'edit'
        }
        this.init();
        window.$(document).ready(function(){
            setTimeout(function(){
                $("#pelanggan").select2();
            }, 100);

        });
    },
    methods: {
        init: function() {
            var que = 0;
            this.$root.is_loading = true;
            var url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            if(url == 'pemesanan-penjualan'){
                this.tipePenjualan = 'pemesanan'
                this.jenis_transaksi = 'penjualan'
            }else if(url == 'pengiriman-penjualan') {
                this.tipePenjualan = 'pengiriman'
                this.jenis_transaksi = 'penjualan'
            }else if(url == 'penagihan-penjualan'){
                this.tipePenjualan = 'penagihan'
                this.jenis_transaksi = 'penjualan'
            }
            this.url = url;
            //get produk list
            this.$http.post("Transaksi/getBahanListProduk").then(result => {
                if(result.data.code == '00'){
                    console.log('bahan list empty')
                }else {
                    this.produkList = result.data.detail
                    que = 1
                    if(que == 1 && this.type == 'edit'){
                        this.getTransaksiDetail()
                    }
                }
                this.$root.is_loading = false;
            })

            //get pelanggan list
            this.$http.post("Kontak/getKontakList/customer").then(result => {
                if(result.data.code == '00'){
                    console.log('bahan list empty')
                }else {
                    this.pelangganList = result.data.detail
                }
            })

            //getnomor transaksi
            if(this.type == 'new'){
                this.$http.post("Transaksi/getNomorTransaksi/penjualan").then(result => {
                    if(result.data.code == '00'){
                        console.log('bahan list empty')
                    }else {
                        this.nomor_transaksi = result.data.detail.nomor
                        this.auto = result.data.detail.auto
                    }
                })
            }




        },
        getTransaksiDetail: function() {
            // get Transaksi detail
            this.$root.is_loading = true
            if(this.$route.params.id_transaksi != null) {
                this.type = 'edit'
                this.id_transaksi = this.$route.params.id_transaksi
                this.$http.post("Transaksi/getTransaksiDetail/"+this.id_transaksi).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.transaksiDetail = result.data.detail
                        if(this.transaksiDetail.detail.tipe_transaksi != 'pemesanan'){
                            this.$router.replace({ path : '/penjualan/list/pemesanan-penjualan' })
                            this.$parent.toastr = {
                                title : 'Error',
                                message: 'Kamu tidak bisa mengedit transaksi ini !',
                                type : 'error'
                            }
                        }
                        this.alamat = this.transaksiDetail.detail.alamat_transaksi
                        this.email = this.transaksiDetail.detail.email_transaksi
                        this.nomor_transaksi = this.transaksiDetail.detail.nomor_transaksi
                        this.auto  = this.transaksiDetail.detail.auto_number
                        this.pesan = this.transaksiDetail.detail.pesan
                        this.memo = this.transaksiDetail.detail.memo
                        this.tanggal_transaksi = new Date(this.transaksiDetail.detail.tanggal_transaksi)
                        this.tanggal_tempo = new Date(this.transaksiDetail.detail.tanggal_jatuh_tempo)
                        this.pelanggan = this.transaksiDetail.detail.id_kontak
                        this.tipePenjualan = this.transaksiDetail.detail.tipe_transaksi
                        this.jenis_transaksi = this.transaksiDetail.detail.jenis_transaksi

                        if(this.transaksiDetail.produkList.length > 0) {
                            var ind = this.dataProdukList.length
                            let that = this
                            var tot = that.transaksiDetail.produkList.length
                            var count = 0
                            that.transaksiDetail.produkList.forEach(function(item,index){
                                that.$http.post("Transaksi/getProdukById/"+item.id_produk+'?kode_produk='+item.transaksi_kode_produk).then(result => {
                                    if(result.data.code == '00'){
                                        console.log('masuk gagal');
                                        that.$nextTick(function(){
                                            that.$parent.toastr = {
                                                title : 'Warning',
                                                message: 'Nama Produk '+item.nama_produk+' tidak ditemukan pada database !',
                                                type : 'error'
                                            }
                                        })
                                        count++
                                        console.log(count)
                                        if(count == tot){
                                            that.finishGetDetail()
                                        }
                                    }else {
                                        that.dataProdukList.push({
                                                id_produk: '',
                                                nama_produk: '',
                                                kode_produk: '',
                                                val: result.data.detail.value,
                                                qty: parseFloat((item.qty).replace(',','.')),
                                                nama_satuan: '',
                                                harga_satuan: 0,
                                                jumlah_harga: 0,
                                                max_qty : 0
                                        });
                                        that.insertValue(ind);
                                        ind++
                                        count++
                                        if(count == tot){
                                            that.finishGetDetail()
                                        }
                                    }
                                })
                            })
                        }
                    }
                }, error => {
                    console.log('gk ok')
                    context.errors = errors;
                });
            }
        },
        auto_alamat: function() {
            var i = $("#pelanggan").select2('val')
            this.pelanggan = this.pelangganList[i].id_kontak
            if(this.alamat == ''){
                this.alamat = this.pelangganList[i].alamat
            }
            if(this.email == ''){
                this.email  = this.pelangganList[i].email
            }
        },
        submit: function(type) {
            if(this.pelanggan == '') {
                var i = $("#pelanggan").select2('val')
                if(i == '' || i == null){
                    this.$parent.toastr = {
                        title : 'Warning',
                        message: 'Pelanggan harus diisi !',
                        type : 'warning'
                    }
                    return false
                }else{
                    this.pelanggan = this.pelangganList[i].id_kontak
                }
            }else {
                var i = $("#pelanggan").select2('val')
                this.pelanggan = this.pelangganList[i].id_kontak
            }

            var formsub = new FormData();
            var objThis = this;
            formsub.append('type',this.type);
            formsub.append('id_kontak',this.pelanggan);
            formsub.append('alamat',this.alamat);
            formsub.append('email', this.email);
            formsub.append('nomor_transaksi',this.nomor_transaksi);
            formsub.append('pesan',this.pesan);
            formsub.append('memo',this.memo);
            formsub.append('tanggal_transaksi',this.formatDate(this.tanggal_transaksi))
            formsub.append('tanggal_tempo',this.formatDate(this.tanggal_tempo))
            formsub.append('auto',this.auto);

            if(this.type == 'edit') {
                formsub.append('id_transaksi',this.id_transaksi)
            }

            $.map(objThis.dataProdukList, function(value,index){
                if(value.id_produk == ''){

                }else{
                    formsub.append('dataProduk['+index+'][id_produk]', value.id_produk);
                    formsub.append('dataProduk['+index+'][nama_produk]', value.nama_produk);
                    formsub.append('dataProduk['+index+'][kode_produk]', value.kode_produk);
                    formsub.append('dataProduk['+index+'][qty]', value.qty);
                    formsub.append('dataProduk['+index+'][harga_satuan]', value.harga_satuan);
                    formsub.append('dataProduk['+index+'][nama_satuan]', value.nama_satuan);
                    formsub.append('dataProduk['+index+'][jumlah_harga]', value.jumlah_harga);
                }
            });

            formsub.append('dibayar',this.dibayar.replace(/\./g, ""));
            formsub.append('total_tagihan',this.total_tagihan);
            formsub.append('tipe_transaksi', this.tipePenjualan);
            formsub.append('jenis_transaksi', this.jenis_transaksi);

            this.$http.post("Transaksi/insertTransaksi", formsub).then(result => {
                console.log(result);
                if(result.data.code == '01') {
                    this.$nextTick(function(){
                        this.$parent.toastr = {
                            title : 'Success',
                            message: 'Transaksi berhasil diinput !',
                            type : 'success'
                        }
                    });
                    if(type == 'normal'){
                        this.$router.replace({ path : '/penjualan/list/'+this.url })
                    }else if(type == 'next') {
                        this.$parent.reRendering();
                    }else {
                        this.$router.replace({ path : window.localStorage.getItem('last_route') })
                    }
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi gagal diinput !',
                        type : 'error'
                    }
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        filterArr: function(array,prop,value) {
            var filtered = [];
            for(var i = 0; i < array.length; i++){
                if(array[i][prop] == value){
                    filtered.push(array[i])
                }
            }
            return filtered;
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        addItem: function() {
			this.dataProdukList.push({
                    id_produk: '',
                    nama_produk: '',
                    kode_produk: '',
                    val: '',
                    qty: 0,
                    nama_satuan: '',
                    harga_satuan: 0,
                    jumlah_harga: 0,
                    max_qty : 0
			});
        },
        getPerkiraanBiaya(id,index) {
            this.bahanProduksiList[index].perkiraan_biaya = priceBahan * this.dataProdukList[index].qty
            $("#"+id).select2("destroy")
            $("#"+id).select2()
        },
        insertValue(index){
            var val = this.dataProdukList[index].val.split("|")
            var priceBahan = val[1]
            this.dataProdukList[index].id_produk = val[0]
            this.dataProdukList[index].nama_produk = val[3]
            this.dataProdukList[index].kode_produk = val[7]
            this.dataProdukList[index].harga_satuan = priceBahan
            this.dataProdukList[index].nama_satuan = val[2]
            if(val[5] == 'n'){
                this.dataProdukList[index].qty_total = val[4]+' (Dipesan '+val[6]+')'
                this.dataProdukList[index].max_qty = val[4]
            }else{
                this.dataProdukList[index].qty_total = val[4]+' (Dipesan '+val[6]+')'+' (Produksi? '+val[5]+')'
                this.dataProdukList[index].max_qty = val[5]
            }
            this.dataProdukList[index].jumlah_harga = priceBahan * this.dataProdukList[index].qty;
        },
        countHarga(index){
            if(this.dataProdukList[index].harga_satuan == 0){
                this.dataProdukList[index].harga_satuan = this.dataProdukList[index].jumlah_harga / this.dataProdukList[index].qty;
            }else{
                this.dataProdukList[index].jumlah_harga = this.dataProdukList[index].harga_satuan * this.dataProdukList[index].qty;
            }
        },
        countSatuan(index){
            this.dataProdukList[index].harga_satuan = this.dataProdukList[index].jumlah_harga / this.dataProdukList[index].qty;
        },
        MoneyCallback(x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        goBack() {
            this.$router.replace({ path : window.localStorage.getItem('last_route') })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        showAddNewKontak: function() {
            console.log('masuk gan')
            this.showAddKontak = true;
        },
        closeAddNewKontak: function() {
            //get pelanggan list
            this.showAddKontak = false;
            this.$http.post("Kontak/getKontakList/pelanggan").then(result => {
                if(result.data.code == '00'){
                    console.log('bahan list empty')
                }else {
                    this.pelangganList = result.data.detail
                }
            })
        },
        showModalUpload: function() {
            this.$modal.show('import-data');
        },
        hideModalUpload: function() {
            this.$modal.hide('import-data');
        },
        handleSelectedFile (convertedData) {
            this.$root.is_loading = !this.$root.is_loading;
            var ind = this.dataProdukList.length
            let that = this
            var tot = convertedData.body.length
            var count = 0
            convertedData.body.forEach(function(item,index){
                var formsub = new FormData
                formsub.append('kode_produk',item.kode_produk);
                queue.push(() => that.$http.post("Transaksi/getProdukByKode",formsub).then(result => {
                    if(result.data.code == '00'){
                        console.log('masuk gagal');
                        that.$nextTick(function(){
                            that.$parent.toastr = {
                                title : 'Warning',
                                message: 'Kode Produk '+item.kode_produk+' tidak ditemukan pada database !',
                                type : 'error'
                            }
                        })
                        count++
                        console.log(count)
                        if(count == tot){
                            that.finishImport()
                        }
                    }else {
                        that.dataProdukList.push({
                                id_produk: '',
                                nama_produk: '',
                                kode_produk: '',
                                val: result.data.detail.value,
                                qty: parseFloat((item.qty).replace(',','.')),
                                nama_satuan: '',
                                harga_satuan: 0,
                                jumlah_harga: 0,
                                max_qty : 0
                        });
                        that.insertValue(ind);
                        ind++
                        count++
                        if(count == tot){
                            that.finishImport()
                        }
                    }
                }))
            })
        },
        finishImport: function() {
            this.$root.is_loading = !this.$root.is_loading;
            this.hideModalUpload()
            this.$parent.toastr = {
                title : 'Success',
                message: 'Import data complete !',
                type : 'success'
            }
        },
        finishGetDetail: function() {
            this.$root.is_loading = false;
            this.bodyRender = false
            this.$nextTick(function(){
                this.bodyRender = true
            })
            let that = this
            this.pelangganList.forEach(function(item,index){
                if(item.id_kontak == that.pelanggan){
                    that.pelanggan = index
                    $("#pelanggan").val(that.pelanggan).trigger('change');
                    return that.pelanggan
                }
            })
        },
        deleteDataProduk: function(index) {
            this.$parent.toastr = {
                title : 'Success',
                message: 'Produk '+this.dataProdukList[index].kode_produk+' | '+this.dataProdukList[index].nama_produk+' berhasil dihapus !',
                type : 'success'
            }
            this.$nextTick(function(){
                this.dataProdukList.splice(index, 1);
                this.bodyRender = false
                this.$nextTick(function(){
                    this.bodyRender = true
                })
            })
        }
    },
    directives: {
      imask: IMaskDirective
    },
    components: {
        AddKontak
    },
    watch: {

    },
    computed: {
        // total_tagihan : function(){
        //     var totals = 0;
        //     this.dataProdukList.forEach(function(item, index){
        //         totals = parseInt(item.jumlah_harga) + totals
        //     })
        //     console.log(totals)
        //     return totals
        // },
        total_semua : function() {
            var totals = 0;
            this.dataProdukList.forEach(function(item, index){
                totals = parseFloat(item.jumlah_harga) + totals
            })
            var bayar = this.dibayar.replace(/\./g, "")
            if(bayar == ''){
                bayar = 0
            }
            return totals - parseFloat(bayar)
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/penjualan/TransaksiPenjualan.vue